import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["skipDefaultValidationCallback"];
export const mergeContentActionPermissionsConfig = (defaultActionPermissions, actionPermissionsOverride) => {
  const actionPermisionsOverrideExceptIgnoreDefaultFlag = _objectWithoutPropertiesLoose(actionPermissionsOverride, _excluded);
  const mergedActionPermissionsConfig = Object.assign({}, defaultActionPermissions, actionPermisionsOverrideExceptIgnoreDefaultFlag);
  if (actionPermissionsOverride['custom'] && defaultActionPermissions['custom'] && !actionPermissionsOverride['skipDefaultValidationCallback']) {
    const customFunctionOverride = actionPermissionsOverride['custom'];
    const defaultCustomFunction = defaultActionPermissions['custom'];
    mergedActionPermissionsConfig['custom'] = args => {
      return defaultCustomFunction(args) && customFunctionOverride(args);
    };
  }
  if ('gates' in actionPermissionsOverride && actionPermissionsOverride['gates']) {
    const defaultGates = defaultActionPermissions['gates'] || [];
    mergedActionPermissionsConfig['gates'] = actionPermissionsOverride['gates'].concat(defaultGates);
  }
  if ('scopes' in actionPermissionsOverride && actionPermissionsOverride['scopes']) {
    const defaultScopes = defaultActionPermissions['scopes'] || [];
    mergedActionPermissionsConfig['scopes'] = actionPermissionsOverride['scopes'].concat(defaultScopes);
  }
  return mergedActionPermissionsConfig;
};
export const mergeActionConfig = (defaultActionConfig, actionOverride) => {
  const mergedActionConfig = Object.assign({}, defaultActionConfig);
  const actionOverrideKeys = Object.keys(actionOverride);
  actionOverrideKeys.forEach(configName => {
    const defaultConfigValue = mergedActionConfig[configName];
    const actionOverrideValue = actionOverride[configName];
    if (configName in defaultActionConfig && defaultConfigValue && actionOverrideValue && (configName === 'enablePermissions' || configName === 'displayPermissions')) {
      mergedActionConfig[configName] = mergeContentActionPermissionsConfig(defaultConfigValue, actionOverrideValue);
    } else if (configName in actionOverride) {
      mergedActionConfig[configName] = actionOverride[configName];
    }
  });
  return mergedActionConfig;
};